export default{
    'navBar.lang': 'Languages',
    'navBar.logout': 'Log Out',
    'navBar.setting': 'Setting',
}